import React from 'react'
import { ROLE_VIEWS } from 'constants/roles'
import ContentCard from 'redesign/components/organisms/content-card'
import routes from 'services/RoutesProvider/routes'
import { HeaderImage } from './styles'
import type { CmsSubcontentBlockProps } from './types'
import useCmsSubContentBlock from './use-cms-subcontent-block'

const CmsSubcontentBlock: React.FC<CmsSubcontentBlockProps> = (props) => {
  const { pushWithRole, subcontentUuid, src, title, titleRef, previewText, isTitleTwoLines } =
    useCmsSubContentBlock(props)

  return (
    <ContentCard
      header={{
        icon: src ? <HeaderImage src={src} /> : undefined,
        title: title ?? '',
        titleRef,
        subtitle: previewText ?? '',
        showChevron: true,
        subtitleOverflowSingleLine: isTitleTwoLines,
      }}
      onClick={() => {
        pushWithRole(`${routes.cmsContentView}/${subcontentUuid}`, ROLE_VIEWS.frontliner)
      }}
      hasBorder
    />
  )
}

export default CmsSubcontentBlock
